// Importing necessary libraries and components
import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions"; // Optional: Uncomment if needed
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";

// Transition component for the dialog
const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

// CommonDialog component definition
export default function CommonDialog({
  message, // Title of the dialog
  description, // Description or content of the dialog
  open, // Boolean to control the visibility of the dialog
  onClose, // Function to handle the dialog close action
}) {
  return (
    <div>
      <Dialog
        open={open} // Controls whether the dialog is open
        TransitionComponent={Transition} // Adds a slide-up transition
        keepMounted // Keeps the dialog mounted in the DOM
        onClose={onClose} // Callback for closing the dialog
        aria-labelledby="alert-dialog-slide-title" // Accessibility label for the title
        aria-describedby="alert-dialog-slide-description" // Accessibility label for the description
      >
        {/* Dialog title */}
        <DialogTitle id="alert-dialog-slide-title">{message}</DialogTitle>

        {/* Dialog content */}
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {description}
          </DialogContentText>
        </DialogContent>

        {/* Dialog actions */}
        <div style={{ flexGrow: 1, textAlign: "center" }}>
          <Grid container spacing={12}>
            <Grid item xs>
              <Button
                style={{
                  alignSelf: "center",
                  textAlign: "center",
                  bottom: "20px",
                }}
                size="medium" // Button size
                variant="contained" // Button style
                onClick={onClose} // Callback for button click
                color="primary" // Button color
              >
                Okay
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </div>
  );
}

// Prop types for the CommonDialog component
CommonDialog.propTypes = {
  message: PropTypes.string, // Title of the dialog
  description: PropTypes.string, // Description or content of the dialog
  open: PropTypes.bool, // Boolean to control the visibility of the dialog
  onClose: PropTypes.func, // Function to handle the dialog close action
};

// Default props for the CommonDialog component
CommonDialog.defaultProps = {
  message: "", // Default title
  description: "", // Default description
  open: false, // Default visibility state
  onClose: () => {}, // Default close action
};
